<script setup lang="ts">
import BaseButton from '@/shared/components/button/BaseButton.vue'
import SvgIcon from '@/shared/components/icon/SvgIcon.vue'

interface Props {
  title: string
  icon: string
  badge?: boolean
}

interface Emits {
  (e: 'click'): void
}

defineProps<Props>()
defineEmits<Emits>()
defineOptions({ inheritAttrs: false })
const model = defineModel<boolean>({ required: true })
</script>

<template>
  <BaseButton
    v-if="icon"
    :title="title"
    class="relative flex items-center rounded-full p-1"
    :class="model ? 'bg-gray-800' : 'hover:bg-gray-800'"
    @click="$emit('click')"
  >
    <SvgIcon :path="icon" class="h-6 w-6" :class="{ 'animate-ring': badge }" v-bind="$attrs" />
    <div v-if="badge" class="absolute right-1 top-1">
      <span class="relative flex size-2.5">
        <span
          class="absolute inline-flex h-full w-full animate-ping rounded-full bg-error/75"
        ></span>
        <span class="relative inline-flex size-2.5 rounded-full bg-error"></span>
      </span>
    </div>
  </BaseButton>
</template>
